<template>
	<div class="search-page">
    <div class="filterbox">
      <el-row :gutter="30">
				<el-col :span="12">
          <div class="table-toolbar-left">
            <el-input
              style="width:230px; margin-left:15px;"
              v-model="query.search"
              size="mini" 
              @keyup.enter.native="query.page=1; currentPage=1; onSearchKeywords()"
              placeholder="商品标题, SKUMap, ShopName, URL"
            >
            </el-input>
            <el-input
              style="width:100px; margin-left:15px;"
              @input="emptysubid = false" :class="emptysubid ? 'alerterrorborder' : ''" 
              v-model="query.subid" size="mini" placeholder="输入订阅ID" 
              @keyup.enter.native="query.page=1; currentPage=1; onSearchSubid(query.subid, query.skuid, $event)"
            >
            </el-input>
            <el-select 
              class="selectchannelsearch" 
              multiple collapse-tags
              v-model="channelId" 
              placeholder="选择渠道" 
              size="mini">
              <el-option
                v-for="item in channels"
                :key="item.value"
                :label="item.name"
                :value="item.value">
              </el-option>
            </el-select>
            <el-button @click="searchWithChannel()" type="primary" size="mini" icon="el-icon-search"></el-button>
          </div>
          <div class="search-topbar-switch">
            <el-switch
              style="margin-left:15px;"
              @change="onConfirmInput()"
              v-model="query.isdel"
              inactive-text="不看已下架"
              :active-value="0"
              :inactive-value="99"
              active-color="#409EFF"
              inactive-color="#999">
            </el-switch>
            <el-switch
              style="margin-left:15px;"
              @change="onConfirmInput()"
              v-model="query.checkSku"
              inactive-text="已匹配SKU"
              :active-value="1"
              :inactive-value="99"
              active-color="#409EFF"
              inactive-color="#999">
            </el-switch>
          </div>
        </el-col>
        <el-col :span="12" style="text-align:right;">
          <el-input 
            style="width:110px;"
            v-model="query.skuMapCode" 
            size="mini" 
            placeholder="输入SkuMapCode" 
            @keyup.enter.native="query.page=1; currentPage=1; onSearchSkuMapcode($event)"
          >
          </el-input>
          <el-input 
            style="width:110px; margin-left:15px;"
            v-model="query.itemcode" 
            size="mini" 
            placeholder="输入ItemCode" 
            @keyup.enter.native="query.page=1; currentPage=1; onSearchItemcode($event)"
          >
          </el-input>
          <el-input 
            style="width:110px; margin-left:15px;"
            v-model="query.skuid" 
            size="mini" 
            placeholder="输入SKUID" 
            @keyup.enter.native="query.page=1; currentPage=1; onSearchSkuid(query.subid, query.skuid, $event)"
          >
          </el-input>
          <el-input 
            style="width:110px; margin-left:15px;"
            v-model="query.assetId" 
            size="mini" 
            placeholder="输入ASSETID" 
            @keyup.enter.native="onSearchAssetid($event)"
          >
          </el-input>
          <el-input 
            style="width:110px; margin-left:15px;"
            v-model="query.shopId" 
            size="mini" 
            placeholder="输入SHOPID" 
            @keyup.enter.native="onSearchShopid($event)"
          >
          </el-input>
        </el-col>
      </el-row>
		</div>

		<div class="commontable">
      <div class="tablebox">
        <el-table 
          :cell-style="getCellStyle" 
          v-loading="loading" 
          size="small" 
          :data="tablelist" 
          @sort-change="sortthiscolumn"
          @selection-change="handleSelectionChange"
          :default-sort="defaultsort"
        >
          <el-table-column prop="AssetId" 
            type="selection" 
            width="40" 
            column-key='AssetId'
          >
					</el-table-column>
          <el-table-column sortable="custom" label="AssetID" width="90px" show-overflow-tooltip>
						<template slot-scope="scope">
							<span v-html="scope.row.AssetID"></span>
						</template>
					</el-table-column>
          <el-table-column label="AssetTitle" show-overflow-tooltip>
						<template slot-scope="scope">
							<a :href="scope.row.AssetURL" target="_blank" v-html="scope.row.AssetTitle"></a>
						</template>
					</el-table-column>
					<el-table-column prop="ItemCode" label="ItemCode" show-overflow-tooltip  width="150px"></el-table-column>
					<el-table-column prop="SkuMapCode" label="SkuMapCode" show-overflow-tooltip  width="150px"></el-table-column>
          <el-table-column label="SkuMap" width="150px" show-overflow-tooltip>
						<template slot-scope="scope">
							<span v-html="scope.row.SkuMap"></span>
						</template>
					</el-table-column>
					<el-table-column prop="AssetContent" label="商品描述" show-overflow-tooltip  width="150px"></el-table-column>
					<el-table-column sortable='custom' prop="Price" label="Price" width="100px"></el-table-column>
          <el-table-column sortable="custom" label="ShopId" width="100px" show-overflow-tooltip>
						<template slot-scope="scope">
							<span v-html="scope.row.ShopId"></span>
						</template>
					</el-table-column>
          <el-table-column label="ShopName" width="150px" show-overflow-tooltip>
						<template slot-scope="scope">
							<span v-html="scope.row.ShopName"></span>
						</template>
					</el-table-column>
					<el-table-column label="下架" width="60px">
            <template slot-scope="scope">
              <el-switch
                :disabled="disabled3"
                @change="takedownItem(scope.row)"
                v-model="scope.row.isDel"
                active-color="#13ce66"
                inactive-color="#999999"
                :active-value="1"
                :inactive-value="0">
              </el-switch>            
            </template>
          </el-table-column>
					<el-table-column prop="SkuId" label="SKUID" width="100px">
            <template slot-scope="scope">
              <el-input :disabled="disabled3" size="mini" v-model="scope.row.SkuId" @keyup.enter.native="keyupEnterSaveSkuId(scope.row, $event)"></el-input>
              <!-- <el-input size="mini" onkeyup="value=value.replace(/[^\d]/g,'')" v-model="scope.row.SkuId" @keyup.enter.native="keyupEnterSaveSkuId(scope.row, $event)"></el-input> -->
            </template>						
					</el-table-column>
        </el-table>
      </div>
      
      <div class="table-pagination table-pagination-left" v-if="totalbrand > 0">
        <el-pagination
          small
          background
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page.sync="currentPage"
          popper-class="pagesizeclass"
          :page-sizes="[25, 50, 100]"
          :page-size="query.size"
          layout="total, prev, pager, next, sizes"
          :total="totalbrand"
        ></el-pagination>
        <div style="width:200px; float:left;">
          <el-input style="width:100px;" placeholder="输入SKUID" v-model="multiedit.skuid" size="mini"></el-input>
          <el-button :disabled='disablededitbtn' type="primary" style="width:90px; margin-left:10px;" size="mini" @click="multiEditSkuid">批量设置</el-button>
        </div>
      </div>

		</div>
	</div>
</template>

<script>
export default {
	data(){
		return{
			query: {
        search: "",
        subid: '',
        skuid: '',
        isdel: '',
        page: 1,
				size: this.getLocalStorage('pagesize1') ? this.getLocalStorage('pagesize1') * 1 : 25,
				order: '',
        checkSku: null,
        assetId: '',
        shopId: '',
        itemcode: '',
        skuMapCode: '',
        channelId: ''
			},
			tablelist: [],
			totalbrand: 0,
			currentPage: 1,
			loading: false,
      searchtype: 0,
      disabled1: this.getLocalStorage('level')/1 === 1 ? true : false,
      disabled3: this.getLocalStorage('level')/1 === 3 ? true : false,
      emptysubid: false,
      newskuid: '',
      multiedit: {
        assetid: [],
        skuid: '',
        taskid: ''
      },
      disablededitbtn: true,
      tableorder: '',
      defaultsort: {
        prop: 'Price',
        order: ''
      },
      channels: [{
        name: '',
        value: ''
      }],
      channelId: []
		}
	},

	mounted(){
    if(this.disabled3){
      this.$router.push({ path: "/" })
    }
    let that = this
    that.query.order = that.getLocalStorage('OrderSearch') != undefined ? that.getLocalStorage('OrderSearch') : ''
    if(that.query.order == 10){
      that.defaultsort.order = 'ascending'
    }
    if(that.query.order == 11){
      that.defaultsort.order = 'descending'
    }
    if(that.query.order == ''){
      that.defaultsort.order = null
    }
	},

	methods: {

    getCellStyle({ column }) {
      // TODO 针对Safari表格width与showOverflowTooltip暂不能共存异常
      const tempWidth = column.realWidth || column.width
      if (column.showOverflowTooltip) {
        return {
          minWidth: tempWidth + 'px',
          maxWidth: tempWidth + 'px'
        }
      }

      return {}
    },

    /**
     * 切换每页显示条目数
     */
    handleSizeChange(val) {
      let that = this
      console.log(that.searchtype)
      that.currentPage = 1
      that.query.page = 1
      that.query.size = val
      that.setLocalStorage('pagesize1', val)
      if(that.searchtype == 0){
        that.onSearch()
      }
      if(that.searchtype == 1){
        that.onSearchSubid(that.query.subid, that.query.skuid)
      }
      if(that.searchtype == 2){
        that.onSearchSkuid(that.query.subid, that.query.skuid)
      }
    },

    /**
     * 切换分页
     */
    handleCurrentChange(val) {
      let that = this
      that.query.page = val
      console.log(that.searchtype)
      if(that.searchtype == 0){
        that.onSearch()
      }
      if(that.searchtype == 1){
        that.onSearchSubid(that.query.subid, that.query.skuid)
      }
      if(that.searchtype == 2){
        that.onSearchSkuid(that.query.subid, that.query.skuid)
      }
    },

		/**
		 * 搜索
		 */
		onSearch: function(){
			let that = this
      that.searchtype = 0
			// if(that.query.search === ''){
			// 	return
			// }
			that.searchData()
		},

    onSearchKeywords: function(){
      let that = this
      that.currentPage = 1
      that.query.page = 1
      if(that.query.subid == ''){
        that.emptysubid = true
        that.$message({
          message: '请输入订阅编号',
          type: 'error'
        })
        return
      }
      that.onSearch()
    },

    /**
     * 排序
     */
    sortthiscolumn: function(column){
      if(column.column.label == "AssetID" && column.order == "ascending"){
        this.query.order = 0
        let that = this
        if(that.searchtype == 0){
          that.onSearch()
        }
        if(that.searchtype == 1){
          that.onSearchSubid(that.query.subid, that.query.skuid)
        }
        if(that.searchtype == 2){
          that.onSearchSkuid(that.query.subid, that.query.skuid)
        }
      }else if(column.column.label == "AssetID" && column.order == "descending"){
        this.query.order = 1
        let that = this
        if(that.searchtype == 0){
          that.onSearch()
        }
        if(that.searchtype == 1){
          that.onSearchSubid(that.query.subid, that.query.skuid)
        }
        if(that.searchtype == 2){
          that.onSearchSkuid(that.query.subid, that.query.skuid)
        }
      }else if(column.column.label == "AssetID" && column.order == null){
        this.query.order = ''
        let that = this
        if(that.searchtype == 0){
          that.onSearch()
        }
        if(that.searchtype == 1){
          that.onSearchSubid(that.query.subid, that.query.skuid)
        }
        if(that.searchtype == 2){
          that.onSearchSkuid(that.query.subid, that.query.skuid)
        }
      }else if(column.column.label == "Price" && column.order == "ascending"){
        this.query.order = 10
        let that = this
        if(that.searchtype == 0){
          that.onSearch()
        }
        if(that.searchtype == 1){
          that.onSearchSubid(that.query.subid, that.query.skuid)
        }
        if(that.searchtype == 2){
          that.onSearchSkuid(that.query.subid, that.query.skuid)
        }
        that.setLocalStorage('OrderSearch', 10)
      }else if(column.column.label == "Price" && column.order == "descending"){
        this.query.order = 11
        let that = this
        if(that.searchtype == 0){
          that.onSearch()
        }
        if(that.searchtype == 1){
          that.onSearchSubid(that.query.subid, that.query.skuid)
        }
        if(that.searchtype == 2){
          that.onSearchSkuid(that.query.subid, that.query.skuid)
        }
        that.setLocalStorage('OrderSearch', 11)
      }else if(column.column.label == "Price" && column.order == null){
        this.query.order = ''
        let that = this
        if(that.searchtype == 0){
          that.onSearch()
        }
        if(that.searchtype == 1){
          that.onSearchSubid(that.query.subid, that.query.skuid)
        }
        if(that.searchtype == 2){
          that.onSearchSkuid(that.query.subid, that.query.skuid)
        }
        that.setLocalStorage('OrderSearch', '')
      }else if(column.column.label == "ShopId" && column.order == "ascending"){
        this.query.order = 20
        let that = this
        if(that.searchtype == 0){
          that.onSearch()
        }
        if(that.searchtype == 1){
          that.onSearchSubid(that.query.subid, that.query.skuid)
        }
        if(that.searchtype == 2){
          that.onSearchSkuid(that.query.subid, that.query.skuid)
        }
      }else if(column.column.label == "ShopId" && column.order == "descending"){
        this.query.order = 21
        let that = this
        if(that.searchtype == 0){
          that.onSearch()
        }
        if(that.searchtype == 1){
          that.onSearchSubid(that.query.subid, that.query.skuid)
        }
        if(that.searchtype == 2){
          that.onSearchSkuid(that.query.subid, that.query.skuid)
        }
      }else if(column.column.label == "ShopId" && column.order == null){
        this.query.order = ''
        let that = this
        if(that.searchtype == 0){
          that.onSearch()
        }
        if(that.searchtype == 1){
          that.onSearchSubid(that.query.subid, that.query.skuid)
        }
        if(that.searchtype == 2){
          that.onSearchSkuid(that.query.subid, that.query.skuid)
        }
      }else{
        return
      }
    },

		/**
		 * 查询数据
		 */
		searchData: function(){
			let that = this
      let url = that.API_URL + '/sys/match/link'
      if(that.query.isdel === 99){
        that.query.isdel = ''
      }
      if(that.query.checkSku === 99){
        that.query.checkSku = ''
      }
      let query = JSON.parse(JSON.stringify(that.query))
      let _s = that.query.search.trim().replace(/\s+/g, " ").split(" ")
      query.search = _s.toString()
      let keys = _s
      that.loading = true
      $.ajax({
        url: url,
        type: "GET",
        headers: {'Authorization': 'Bearer '+JSON.parse(localStorage.getItem("token")).val+''},
        changeOrigin: true,
        crossDomain: true,
        data: query,
        success: function(data) {
					console.log('getResultList', data)
					let lists = data.results[1]
					lists.forEach(item =>{
            item.aid = item.AssetID
            item.AssetIDOrigin = JSON.parse(JSON.stringify(item.AssetID))
						item.AssetID = that.highlighted(keys, item.AssetID.toString())
						item.AssetTitle = that.highlighted(keys, item.AssetTitle===null ? '' : item.AssetTitle)
						item.SkuMap = that.highlighted(keys, item.SkuMap===null ? '' : item.SkuMap)
						item.ShopId = that.highlighted(keys, item.ShopId===null ? '' : item.ShopId.toString())
						item.ShopName = that.highlighted(keys, item.ShopName===null ? '' : item.ShopName)
            item.isDel = item.isDel == 2 ? 1 : item.isDel
					})
					that.tablelist = lists
					that.totalbrand = data.results[0][0].Count >= 1000 ? 1000 : data.results[0][0].Count
					that.loading = false
        },
        error: function(response) {
          console.log('getResultList', response)
        }
      })
		},

    /**
     * 回车提交SKUID修改
     */
    keyupEnterSaveSkuId: function(row, envet){
      let that = this
      if(row.SkuId === ''){
        that.$message.error('SKUID不能为空')
        return false
      }
      if(isNaN(row.SkuId)){
        that.$message.error('SKUID只能输入大于等于-1的数')
        return false
      }
      if(row.SkuId/1 < -1){
        that.$message.error('SKUID只能输入大于等于-1的数')
        return false
      }
      that.changeSkuId(row)
      envet.target.blur()
    },

    /**
     * 保存SKUID修改
     */
    changeSkuId: function(row){
      let that = this
      row.isedittype = false
      let url = that.API_URL + '/sys/rule/item'
      $.ajax({
        url: url,
        type: "PUT",
        headers: {'Authorization': 'Bearer '+JSON.parse(localStorage.getItem("token")).val+''},
        changeOrigin: true,
        crossDomain: true,
        // data: {subid: that.query.subid, skuid: row.SkuId, assetid: row.AssetIDOrigin},
        data: {taskid: row.TaskId, skuid: row.SkuId, assetid: row.AssetIDOrigin},
        success: function(data) {
					console.log('changeSkuId', data)
					that.$message.success('修改成功')
        },
        error: function(response) {
					console.log('changeSkuId', response)
					that.$message.error('修改失败')
        }
      })
    },

    /**
     * 下架
     */
    takedownItem: function(row){
      let that = this
      row.isedittype = false
      let url = that.API_URL + '/sys/result/set'
      $.ajax({
        url: url,
        type: "PUT",
        headers: {'Authorization': 'Bearer '+JSON.parse(localStorage.getItem("token")).val+''},
        changeOrigin: true,
        crossDomain: true,
        data: {assetid: row.AssetIDOrigin, status: row.isDel},
        success: function(data) {
					console.log('takedownItem', data)
					that.$message.success('修改成功')
        },
        error: function(response) {
					console.log('takedownItem', response)
					that.$message.error('修改失败')
        }
      })      
    },

    /**
     * 新增条件搜索
     */
    onConfirmInput: function(){
      this.searchData()
    },

    /**
     * 搜索subid
     */
    onSearchSubid: function(subid, skuid, envet){
      let that = this
      that.searchtype = 0
      if(skuid !== ''){
        that.checkSubid(subid, skuid)
      }else{
        this.getChannel(subid)
        this.searchData()
      }
      envet.target.blur()
    },

    /**
     * 搜索skuid
     */
    onSearchSkuid: function(subid, skuid){
      let that = this
      that.searchtype = 2
      // that.query.page = 1
      // that.currentPage = 1
      if(subid != ''){
        if(skuid == '-1' || skuid == '0' || skuid == ''){
          that.searchtype = 0
          this.searchData()
        }else{
          that.checkSkuid(subid, skuid)
        }
      }else{
        this.searchData()
      }
      // envet.target.blur()
    },
    onSearchAssetid: function(envet){
      let that = this
      that.query.page = 1
      that.currentPage = 1
      that.searchData()
      envet.target.blur()
    },
    onSearchShopid: function(envet){
      let that = this
      that.query.page = 1
      that.currentPage = 1
      that.searchData()
      envet.target.blur()
    },
    onSearchItemcode: function(envet){
      let that = this
      that.query.page = 1
      that.currentPage = 1
      that.searchData()
      envet.target.blur()
    },
    onSearchSkuMapcode: function(envet){
      let that = this
      that.query.page = 1
      that.currentPage = 1
      that.searchData()
      envet.target.blur()
    },

    /**
     * 检查SKUID对应SUBID
     */
    checkSkuid: function(subid, skuid){
      let that = this
      let url = that.API_URL + '/sys/match/sku'
      $.ajax({
        url: url,
        type: "GET",
        headers: {'Authorization': 'Bearer '+JSON.parse(localStorage.getItem("token")).val+''},
        changeOrigin: true,
        crossDomain: true,
        data: {
          subid: subid,
          sukid: ''
        },
        success: function(data) {
          console.log('checkSkuid', data)
          let skuidarr = []
          for(let i=0; i<data.results.length; i++){
            skuidarr.push(data.results[i].skuid/1)
          }
          if(skuidarr.indexOf(skuid/1) != -1){
            that.searchData()
          }else{
            that.$message.error('SKUID超出当前订阅范围')
          }
        },
        error: function(response) {
          console.log('checkSkuid', response)
        }
      })
    },

    /**
     * 检查SUBID对应SKUID
     */
    checkSubid: function(subid, skuid){
      let that = this
      let url = that.API_URL + '/sys/match/sku'
      $.ajax({
        url: url,
        type: "GET",
        headers: {'Authorization': 'Bearer '+JSON.parse(localStorage.getItem("token")).val+''},
        changeOrigin: true,
        crossDomain: true,
        data: {
          subid: '',
          sukid: skuid
        },
        success: function(data) {
          console.log('checkSkuid', data)
          if(data.results[0].subid/1 == subid/1){
            that.searchData()
          }else{
            that.$message.error('SUBID超出当前SKU范围')
          }
        },
        error: function(response) {
          console.log('checkSkuid', response)
        }
      })
    },

    /**
     * 全选
     */
    handleSelectionChange: function(val){
      this.multiedit.taskid = val.map(item => {
        return item.TaskId
      })
      this.multiedit.assetid = val.map(item => {
        return item.aid
      })
      this.disablededitbtn = this.multiedit.assetid.length > 0 ? false : true
    },

    /**
     * 批量修改
     */
    multiEditSkuid: function(){
      let that = this
      if(that.multiedit.skuid == ''){
        that.$message.error('SKUID不能为空')
        return
      }
      let url = that.API_URL + '/sys/rule/setmoreitem'
      that.multiedit.taskid = that.multiedit.taskid[0]
      that.multiedit.assetid = that.multiedit.assetid.join(',')
      $.ajax({
        url: url,
        type: "PUT",
        headers: {'Authorization': 'Bearer '+JSON.parse(localStorage.getItem("token")).val+''},
        changeOrigin: true,
        crossDomain: true,
        data: that.multiedit,
        success: function(data) {
					console.log('multiEditSkuid', data)
					that.$message.success('修改成功')
        },
        error: function(response) {
					console.log('multiEditSkuid', response)
					that.$message.error('修改失败')
        }
      })
    },

    /**
     * 获取渠道列表
     * match/getChannel
     */
    getChannel: function(subid){
      let that = this
      let url = that.API_URL + '/sys/match/getChannel?subid=' + subid
      $.ajax({
        url: url,
        type: "GET",
        headers: {'Authorization': 'Bearer '+JSON.parse(localStorage.getItem("token")).val+''},
        changeOrigin: true,
        crossDomain: true,
        success: function(data) {
          console.log('getChannel', data)
          let _cid = data.results[0].channel.split(',')
          let _cname = data.results[0].channelname.split(',')
          let _channel = []
          for(let i=0; i<_cid.length; i++){
            let _obj = {
              name: _cname[i],
              value: _cid[i]
            }
            _channel.push(_obj)
          }
          that.channels = _channel
        },
        error: function(response) {
          console.log('getChannel', response)
        }
      })
    },

    /**
     * 输入渠道是触发
     */
    searchWithChannel: function(){
      let that = this
      that.query.channelId = that.channelId.join(',')
      that.query.page = 1
      that.currentPage = 1
      that.searchData()
    },

	}
}
</script>